"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {};
exports["default"] = void 0;

var _fastclick = require("./fastclick");

Object.keys(_fastclick).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _fastclick[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _fastclick[key];
    }
  });
});

var _log = require("./log");

Object.keys(_log).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _log[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _log[key];
    }
  });
});

var _href = require("./href");

Object.keys(_href).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _href[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _href[key];
    }
  });
});

/**
 * @file vue 扩展注入
 * @author qiaogang
 * @date 2019-12-12
 */
var _default = {
  install: function install(_vue) {
    (0, _href.injectHrefMethod)(_vue);
    (0, _fastclick.injectFastClickDirective)(_vue);
    (0, _log.injectLogDirective)(_vue);
  }
};
exports["default"] = _default;